// AUTO-GENERATED by scripts/gen-version.mjs — do not edit by hand.
export const APP_VERSION = "0.9.10d" as const;
export const COMMIT_SHA = "6e8ecc1" as const;
export const BUILD_TIME = "2026-11-04T00:11:33.748Z" as const;
